import { useApolloClient } from '@apollo/react-hooks';
import {
  ReportOutageBySpListRequest,
  ReportOutageResponse,
} from '../../../__generated__/pge-types';
import { reportOutageBySpListMutation } from '../../outage/outage-center/outage-map-panel/queries';

export function useReportOutage() {
  const apolloClient = useApolloClient();

  const reportOutageForLoggedInUser = async (
    payload: ReportOutageBySpListRequest,
  ) => {
    const { data } = await apolloClient.mutate<{
      reportOutageBySpList: ReportOutageResponse;
    }>({
      mutation: reportOutageBySpListMutation,
      variables: {
        payload,
      },
    });
    return data;
  };

  return {
    reportOutageForLoggedInUser,
  };
}
